import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import Api from 'src/services/ApiService';
import {
  ChangeTransactionSerialPayload,
  ChangeTransactionSerialResponse,
  CommonAxiosResponse,
  CommonResponseMessage,
  UpdateTransactionDetailRequest,
  ValidatedNewSerialNoPayload,
  ValidatedNewSerialNoResponse
} from 'src/types';

export const updateTransactionDetailThunk = createAsyncThunk<
  CommonAxiosResponse<CommonResponseMessage>,
  UpdateTransactionDetailRequest,
  { state: RootState }
>('transaction/updateTransactionDetailThunk', async (data) => {
  let request = data;
  request.remarks = request?.remarks || 'update data';
  delete request.order_no; // EDITING OF ORDER_NO NOT ALLOWED.

  const response = await Api.patch(
    `/transaction/details/update/${request?.id}`,
    request
  );
  // if (!response.success) {
  //   throw new Error('Failed updateTransactionDetailThunk');
  // }
  return response;
});

export const changeTransactionSerialThunk = createAsyncThunk<
  CommonAxiosResponse<ChangeTransactionSerialResponse>,
  ChangeTransactionSerialPayload,
  { state: RootState }
>('transactions/changeTransactionSerialThunk', async (data) => {
  const response = await Api.patch(
    '/transactions/item_change_serial_no/update',
    data
  );

  return response;
});

export const validateNewSerialNoThunk = createAsyncThunk<
  CommonAxiosResponse<ValidatedNewSerialNoResponse>,
  ValidatedNewSerialNoPayload,
  { state: RootState }
>('transaction/validateNewSerialNoThunk', async (data) => {
  const response = await Api.get(
    `/transactions/item_change_serial_no/validate/get`,
    data
  );
  if (!response.success) {
    throw new Error('Failed at validateNewSerialNoThunk.');
  }
  return response;
});
